import React, {useEffect, useMemo, useRef} from "react";
import {useGoogleMapsApi} from "../../../../providers/googleMapsApiProvider";

function AddressAutocomplete(props) {
    const [value, setValue] = React.useState(props.value);
    const autocompleteInput = useRef(null);
    const googleMapsApiContext = useGoogleMapsApi();


    const autocompleteOptions = useMemo(() => {
        const options = {};

        if (props.types) {
            options.types = props.types;
        }

        // Restrict to Great Britain by default, allow override/merge from props
        options.componentRestrictions = {
            country: "gb",
            ...(props.componentRestrictions || {}),
        };

        return options;
    }, [props.types, props.componentRestrictions]);
    

    useEffect(() => {
        if (!window.google || !googleMapsApiContext.gmAPILoaded) {return;}
        if (!autocompleteInput.current) {return;}

        /*let autocompleteOptions = {};
        if (props.types) {autocompleteOptions.types = props.types;}
        if (props.componentRestrictions) {autocompleteOptions.componentRestrictions = props.componentRestrictions;}*/

        const autocomplete = new window.google.maps.places.Autocomplete(
            autocompleteInput.current,
            autocompleteOptions
        );

        autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace();

            if (place) {
               setValue(place.name);
               props.onChange(place);
            }
        });
    }, [googleMapsApiContext.gmAPILoaded]);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);


    const onManualSubmit = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            props.onChange(value);
        }
    }
    const onManualClick = (e) => {
        e.preventDefault();
        props.onChange(value);
    }


    let className = ['form-control', 'input-onmap', 'ps-3'];
    if (props.className) {
        const classNameParts = props.className.split(' ');
        classNameParts.forEach((part) => {
            if (className.indexOf(part) === -1) {
                className.push(part);
            }
        });
    }
    return (<>
        <div className="position-absolute end-0 top-50 translate-middle-y pe-4 me-1 cursor-pointer" onClick={onManualClick}>
            <i className="ti ti-search fs-4"></i>
        </div>

        <input
            id={'top-search'}
            type="text"
            className={className.join(' ')}
            value={value}
            onChange={(e) => {setValue(e.target.value)}}
            ref={autocompleteInput}
            placeholder={'Search address or Lat,Long...'}
            onKeyDown={onManualSubmit}
        />
    </>
    );
}

export default AddressAutocomplete;